// fa, en
export default {
  fa: {
    me: "من",
    about: "درباره",
    education: "تحصیلات",
    experience: "تجربه",
    skills: "تخصص",
    achievement: "دستاورد",
    publication: "انتشارات",
    amir: "امیرحسین",
    mohajeri: "مهاجری",
    developer: "توسعه دهنده",
    role: "متخصص ژنتیک پزشکی و پژوهشگر",
    amper: "و",
    researcher: "پژوهشگر",
    about_text: "از سنین پایین، علاقه‌ی زیادی به علوم تجربی و مکانیسم های زیستی داشتم که در نهایت مرا به مسیر حرفه‌ای در ژنتیک پزشکی هدایت کرد. من دارای دانش گسترده‌ای در زمینه های مختلف علوم آزمایشگاهی پزشکی از جمله هماتولوژی، ایمونولوژی، میکروبیولوژی، بیوشیمی و ژنتیک پزشکی هستم و مهارت‌های نظری و عملی محکمی در زمینه‌ی آزمایش‌های تشخیصی و پژوهش دارم. همچنین، به‌طور جدی در حوزه‌ی ارتباطات علمی به‌ویژه در ترجمه و نگارش مقالات علمی به زبان انگلیسی فعالیت می‌کنم.",
    interest: "زمینه‌های پژوهشی من عبارتند از:",
    download_cv: "دانلود CV",
    contact: "تماس",
    contact_me: "تماس با من",
    more: "بیشتر",
    attachment: "ضمیمه",
    download: "دانلود",
    email: "ایمیل",
    gpa: "معدل",
    mobile: "09050966417",

    // Education Section
    grades_modal_text: "بعضی نمرات مهم",
    human_genetics: "ژنتیک انسانی",
    medical_genetics: "ژنتیک پزشکی",
    experimental_sciences: "تجربی",

    phd: "دکتری تخصصی",
    mums: "دانشگاه علوم پزشکی مشهد",
    mums_year: "1403 - حال",
    cur_study: "در حال تحصیل",

    ms: "کارشناسی ارشد",
    hums: "دانشگاه علوم پزشکی هرمزگان",
    hums_year: "1399 - 1402",

    bachelor: "مقطع لیسانس",
    iaum: "دانشگاه آزاد اسلامی واحد مشهد",
    iaum_year: "1395 - 1399",
    iaum_field: "علوم آزمایشگاهی",

    diploma: "دیپلم",
    mobin: "دبیرستان نمونه دولتی مبین",
    mobinYear: "1391 - 1395",

    // Experience Section
    full_time: "تمام وقت",
    part_time: "پاره وقت",
    web_developer: "توسعه دهنده وب",

    nef: "بنیاد ملی نخبگان",
    nef_date: "1403 - حال",

    reviewer: "داور",
    tmr: "گروه انتشارات TMR",
    tmr_date: "1400 - حال",

    member: "عضو",
    yerc: "باشگاه پژوهشگران جوان و نخبگان",
    yerc_date: "1399 - حال",

    scientist: "کارشناس علوم آزمایشگاهی",
    hospitals: "بیمارستان‌های 17 شهریور، آریا، فارابی و ۲۲ بهمن",
    hospitals_date: "1398 - 1399",

    editor: "سردبیر",
    ghasedak: "مجله علمی قاصدک",
    ghasedak_date: "1397 - 1398",

    // Skills Section
    try: "زمینه‌های پژوهشی من عبارتند از",

    // Achievement Section
    scoreboard: "جدول امتیازات",
    certificate: "گواهی",
    participant: "شرکت کننده",
    stage: "مرحله نهایی",

    phd_rank: "رتبه یک",
    phd_time: "دی 1403",

    dr_rank: "رتبه یک",
    dr_time: "مرداد 1403",

    nbo_rank: "مقام بیست و پنجم",
    nbo_time: "تیر 1400",

    mhg_rank: "مقام سی و هشتم",
    mhg_time: "آذر 1399",

    mg_rank: "مقام سیزدهم",
    mg_time: "شهریور 1399",

    tg_rank: "دانش آموخته برتر",
    tg_time: "شهریور 1399",

    iccke: "گواهی برگزاری کارگاه در کنفرانس ICCKE 2022",
    iccke_time: "آبان 1401",
    iccke_sub: "کارگاه 4 ساعته با موضوع هوش مصنوعی قابل توضیح",
    iccke_site: "سایت کنفرانس",

    // Contact Section
    contactText: "برای اطلاعات بیشتر با من در تماس باشید.",
    contactPlace: "ایران، مشهد",
    contactLink: "هم‌چنین از طریق این <a href='https://blog.abolfazlmohajeri.ir/contact-me' target='_blank'> لینک </a>، می‌توانید برای ارتباط با من استفاده کنید.",

    // Contact Section
    made: "ساخته شده با ",
    by: "توسط ",
  },
  en: {
    me: "Me",
    about: "About",
    education: "Education",
    experience: "Experience",
    skills: "Skills",
    achievement: "Achievement",
    publication: "Publication",
    amir: "Amirhossein",
    mohajeri: "Mohajeri",
    developer: "Developer",
    role: "Medical Geneticist and Researcher",
    amper: "&",
    researcher: "Researcher",
    about_text: "From an early age, I have been driven by a strong interest in experimental science and biological mechanisms, which led me to a career in medical genetics. I possess broad expertise in medical laboratory sciences, including hematology, immunology, microbiology, biochemistry, genetics, and hormone analysis, with solid theoretical and practical skills in diagnostic testing and research. Additionally, I am deeply engaged in scientific communication, particularly in translating and authoring scholarly articles in English.",
    interest: "My research fields are as follows:",
    download_cv: "Download CV",
    contact: "Contact",
    contact_me: "Contact Me",
    more: "More",
    attachment: "Attachment",
    download: "Download",
    email: "Email",
    gpa: "GPA",
    mobile: "+989050966417",

    // Education Section
    grades_modal_text: "Some Important Grades",
    human_genetics: "Human Genetics",
    medical_genetics: "Medical Genetics",
    experimental_sciences: "Experimental Sciences",

    phd: "PhD",
    mums: "Mashhad University of Medical Sciences",
    mums_year: "2024 - Present",
    cur_study: "Currently Studying",

    ms: "Master of Science",
    hums: "Hormozgan University of Medical Sciences",
    hums_year: "2020 - 2023",

    bachelor: "Bachelor’s Degree",
    iaum: "Islamic Azad University Of Mashhad",
    iaum_year: "2016 - 2020",
    iaum_field: "Medical Laboratory Sciences",

    diploma: "Diploma",
    mobin: "Mobin High School (Magnet School)",
    mobinYear: "2012 – 2016",

    // Experience Section
    full_time: "Full Time",
    part_time: "Part Time",
    web_developer: "Web Developer",

    nef: "National Elites Foundation",
    nef_date: "2024 - Present",

    reviewer: "Reviewer",
    tmr: "TMR Publishing Group",
    tmr_date: "2021 - Present",

    member: "Member",
    yerc: "Young and Elite Researchers Club",
    yerc_date: "2020 - Present",

    scientist: "Medical Laboratory Scientist",
    hospitals: "17 Shahrivar/Aria/Farabi/22 Bahman hospitals",
    hospitals_date: "2019 - 2020",

    editor: "Editor in Chief",
    ghasedak: "Qasedak Scientific Journal",
    ghasedak_date: "2017 - 2018",

    // Skills Section
    try: "My research fields are as follows",

    // Achievement Section
    scoreboard: "ScoreBoard",
    certificate: "Certificate",
    participant: "Participant",
    stage: "Final Stage",

    phd_rank: "First Place",
    phd_time: "December 2024",

    dr_rank: "First Place",
    dr_time: "August 2024",

    nbo_rank: "Twenty Fifth Place",
    nbo_time: "June 2021",

    mhg_rank: "38th Place",
    mhg_time: "September 2020",

    mg_rank: "13th Place",
    mg_time: "August 2020",

    tg_rank: "Top Grad Student",
    tg_time: "August 2020",

    iccke: "Certificate OF ICCKE Workshop Presentation",
    iccke_time: "November 2022",
    iccke_sub: "4 Hour Workshop Entitled Explainable Artificial Intelligence",
    iccke_site: "Conference Site",

    // Contact Section
    contactText: "Do Not Hesitate To Contact Me For More Information.",
    contactPlace: "Mashhad, Iran",
    contactLink: "You can also use this <a href='https://blog.abolfazlmohajeri.ir/contact-me' target='_blank'> link </a> to contact me.",

    // Contact Section
    made: "Made with ",
    by: "by ",
  }
}
